export default __webpack_public_path__ + "static/media/googleIcon.b58cd697.svg";